import React from "react";
import { useIntl } from "react-intl";

import LoginForm from "../loginForm";
import FormLayout from "components/FormLayout";

function LoginLayout() {
  const intl = useIntl();

  return (
    <FormLayout label={intl.messages["loginScene.login.logoLoginLabel"]}>
      <LoginForm />
    </FormLayout>
  );
}

export default LoginLayout;
